import { render, staticRenderFns } from "./edit-duration-dialog.vue?vue&type=template&id=006139b4&scoped=true&"
import script from "./edit-duration-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-duration-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006139b4",
  null
  
)

export default component.exports